export const TOSv1 = () => {
  return (
    <div>
      <h3 className="accept-terms-modal__description">
        Please review our{' '}
        <a href="https://www.willowservicing.com/tos" target="_blank" rel="noopener noreferrer">
          Terms
        </a>{' '}
        and{' '}
        <a href="https://www.willowservicing.com/privacy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>{' '}
        and{' '}
        <a href="https://www.willowservicing.com/paperless-disclosures" target="_blank" rel="noopener noreferrer">
          Paperless Disclosures
        </a>
        , as well as our partner Dwolla’s{' '}
        <a href="https://www.dwolla.com/legal/tos/" target="_blank" rel="noopener noreferrer">
          Terms
        </a>{' '}
        and{' '}
        <a href="https://www.dwolla.com/legal/privacy/" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        .
      </h3>{' '}
    </div>
  );
};
